// src/store/reducers/documentListProcessSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Process {
  processId: number;
  processName: string;
}

const initialState: Process[] = [];

const documentListProcessSlice = createSlice({
  name: 'documentListProcess',
  initialState,
  reducers: {
    setDocumentListProcessSlice(state, action: PayloadAction<Process[]>) {
      return action.payload;
    }
  }
});

export const { setDocumentListProcessSlice } = documentListProcessSlice.actions;
export default documentListProcessSlice.reducer;
